export default __webpack_public_path__ + "static/media/labor-team-no-data-icon.5d5d4e27.svg";